export const actions = {
  save: 'SAVE',
  close: 'CLOSE',
  execute: 'EXECUTE', // проведение
  cancel: 'CANCEL_EXECUTE', // Отмена проведения
  reload: 'RELOAD', // Повторная Загрузка
};

export default actions;
